export default "__VITE_ASSET__DwiTCRba__"